import type { MemberGroup } from './notificationGroupTypes';

export type CarSmsType = 'booking' | 'service-reminder';

/** The consent pair alone, so the review sentences can ask about a driver-to-be, not a matrix row. */
type SmsConsent = Pick<MemberGroup, 'smsBookingNotifications' | 'smsRecallProposals'>;

export const acceptsCarSms = (row: SmsConsent, type: CarSmsType) =>
  type === 'booking' ? row.smsBookingNotifications : row.smsRecallProposals;

export const acceptsAnyCarSms = (row: SmsConsent) =>
  acceptsCarSms(row, 'booking') || acceptsCarSms(row, 'service-reminder');

export const isSilenced = (member: SmsConsent) => !acceptsAnyCarSms(member);
